module.exports = __webpack_public_path__ + "img/cave102.66c3e03d.jpg";